import styled from 'styled-components';

export const ItemPrice = styled.span`
  font-size: 0.9rem;
  color: ${Styles.color.grey.one};
  white-space: nowrap;
`;
